<template>
	<div class="layout-topbar">
		<!-- <button class="p-link layout-topbar-menu-button layout-topbar-button"
			v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', 
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true}">
			<i class="pi pi-ellipsis-v"></i>
		</button> -->
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
			<i class="pi pi-bars"></i>
		</button>
		<!-- <router-link to="/" class="layout-topbar-logo">
			<img src="@/assets/logo.png" />
			<span class="mx-2 font-bold">آسا پرواز</span>
		</router-link> -->

		<ul class="layout-topbar-menu hidden lg:flex origin-top justify-content-end">
			<li>
				<button @click="$router.go(-1)" class="p-link layout-topbar-button">
					<i class="pi pi-arrow-left"></i>
				</button>
			</li>
			<li>
				<button @click.prevent="logout" class="p-link layout-topbar-button">
					<i class="pi pi-sign-out"></i>
					<span>خروج</span>
				</button>
			</li>
			<!-- <li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-cog"></i>
					<span>Settings</span>
				</button>
			</li>
			<li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-user"></i>
					<span>Profile</span>
				</button>
			</li> -->
		</ul>
	</div>
</template>

<script>
export default {
	methods: {
		onMenuToggle(event) {
			this.$emit('menu-toggle', event);
		},
		onTopbarMenuToggle(event) {
			this.$emit('topbar-menu-toggle', event);
		},
		topbarImage() {
			return this.$appState.darkTheme ? '@/assets/logo.png' : '@/assets/logo.png';
		},
		logout() {
			this.$toast.add({ severity: 'success', summary: 'خروج', detail: 'خوش آمدید', life: 1000 })
			setTimeout(() => {
				this.$auth.logout();
			}, 500);
		}
	},
	computed: {
		darkTheme() {
			return this.$appState.darkTheme;
		}
	}
}
</script>
